<div *ngFor="let conflict of conflicts$ | ngrxPush; trackBy: trackByConflict">
  <pr-warning>
    {{ conflict }}
  </pr-warning>
</div>
